import React from 'react';
import { Card, Typography, List, Button } from 'antd';
import { CheckCircleOutlined, BookOutlined, TeamOutlined, BugOutlined, MessageOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import usePageTracking from '../../utils/usePageTracking';

const NoticePage = () => {
  // GA4 页面追踪
  usePageTracking('重要通知');
  
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate('/'); // 導航到首頁
  };

  const noticeItems = [
    {
      icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
      title: '1. 認證你的郵箱',
      content: '請馬上到自己的郵箱點擊認證連結信件，完成認證，以免相關權益受損。'
    },
    {
      icon: <BookOutlined style={{ color: '#1890ff' }} />,
      title: '2. 網站定位與願景',
      content: '本網站致力於打造華人區最完整、最省力、最智能的美股中文 AI 資訊平台，幫助投資者快速掌握財報、翻譯與分析。並且以巴菲特價值成長理念，篩選出最優質護城河深CP值高且富有成長動能的個股。'
    },
    {
      icon: <TeamOutlined style={{ color: '#faad14' }} />,
      title: '3. 目前僅開放推薦註冊',
      content: '本平台仍在開發階段，目前僅限透過「推薦碼」進行註冊。您可在個人資料頁面找到推薦連結(碼)並分享給親友，可免費享用「每月12美金」的體驗。AI功能 開發階段每日會有30次的查詢限制。'
    },
    {
      icon: <BugOutlined style={{ color: '#f5222d' }} />,
      title: '4. 數據仍在持續優化中',
      content: '部分數據可能仍存在延遲或缺漏的情況，我們歡迎您在部落格留言區提出發現的問題，我們會優先處理。'
    },
    {
      icon: <MessageOutlined style={{ color: '#722ed1' }} />,
      title: '5. 功能建議回饋機制',
      content: '若您有希望新增的功能或改進建議，亦歡迎發佈至部落格討論區，您的聲音對我們非常重要！'
    }
  ];

  return (
    <div style={{ 
      padding: '24px',
      maxWidth: '800px',
      margin: '0 auto',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <Card style={{ borderRadius: '8px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <Typography.Title level={2} style={{ color: '#1890ff', marginBottom: '16px' }}>
            歡迎加入我們的測試計畫！
          </Typography.Title>
          <Typography.Text style={{ fontSize: '16px', color: '#666' }}>
            在使用本網站前，請留意以下事項：
          </Typography.Text>
        </div>

        <List
          itemLayout="vertical"
          dataSource={noticeItems}
          renderItem={(item) => (
            <List.Item style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '20px', marginBottom: '20px' }}>
              <List.Item.Meta
                avatar={item.icon}
                title={
                  <Typography.Title level={4} style={{ color: '#1890ff', marginBottom: '8px' }}>
                    {item.title}
                  </Typography.Title>
                }
                description={
                  <Typography.Text style={{ fontSize: '14px', lineHeight: '1.6', color: '#333' }}>
                    {item.content}
                  </Typography.Text>
                }
              />
            </List.Item>
          )}
        />

        <div style={{ textAlign: 'center', marginTop: '32px' }}>
          <Button 
            type="primary" 
            size="large"
            onClick={handleContinue}
            style={{ 
              padding: '12px 32px',
              height: 'auto',
              fontSize: '16px',
              borderRadius: '6px'
            }}
          >
            我已了解，開始使用
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default NoticePage; 